import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7df823ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-center" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tooltipText" }, "指投料数中发现的材料废品数，属于前道工序中未检出的废品。", -1))
const _hoisted_4 = { class: "flex items-center justify-between" }
const _hoisted_5 = { class: "text-center value" }
const _hoisted_6 = { class: "center" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "BackupList_box"
}

import { computed, defineComponent, PropType, ref, toRaw, watch } from "vue";
import { SmallDashOutlined, InfoCircleOutlined } from '@ant-design/icons-vue';
import titleButton from "./title-button.vue"
import MessageShow from './MessageShow.vue';
import { IPostMachineProductionCountReportMaterialBadDetailList } from "@/api/machine/index.type.public";
import { cloneDeep } from "lodash";


export default /*#__PURE__*/_defineComponent({
  __name: 'j-text3',
  props: {
  name: {
    required: true,
    type: String,
  },
  //修改数据
  value: {
    required: false,
    type: Number,
  },
  wastList: {
    required: true,
    type: Object as PropType<IPostMachineProductionCountReportMaterialBadDetailList[]>
  }
},
  emits: ['onChangeValue', 'wastUpdata'],
  setup(__props, { emit }) {

const props = __props;



const visibleReceiving = ref<boolean>(false)
const decevList = ref(props.wastList)
const BackupList = ref([])
const openBadOutPut = () => {
  BackupList.value = cloneDeep(decevList.value)
  visibleReceiving.value = true;
}
//更新实时数
const updateRealData = (sign: string, newValue: number) => {
  BackupList.value.map(item => {
    if (item.code == sign) item.num = newValue
  })
}
const wastNum = computed(() => {
  let wastTatal = 0
  BackupList.value.map(item => {
    wastTatal += item.num
  })
  return wastTatal
});
//材废确认
const onReceivingHandleOk = (status: 'cance' | 'complete') => {
  visibleReceiving.value = false;
  if (status === 'complete') {
    emit('wastUpdata', BackupList.value, wastNum.value)
  } else {
    emit('wastUpdata', decevList.value)
  }
}
watch(() => props.wastList, newVal => {
  decevList.value = newVal
}, {
  deep: true,
  immediate: true
})

return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(__props.name), 1),
      _createVNode(_component_a_tooltip, {
        placement: "top",
        trigger: "click"
      }, {
        title: _withCtx(() => [
          _hoisted_3
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(InfoCircleOutlined), { class: "tooltipIcon" })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(__props.value), 1),
      _createElementVNode("div", {
        class: "icon-button",
        onClick: openBadOutPut
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(SmallDashOutlined))
        ])
      ])
    ]),
    (visibleReceiving.value)
      ? (_openBlock(), _createBlock(MessageShow, {
          key: 0,
          show: visibleReceiving.value,
          title: "材废填写",
          onOnResultOperate: onReceivingHandleOk,
          maskClosable: false
        }, {
          default: _withCtx(() => [
            (BackupList.value.length < 1)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, "当前无不良品项，请联系管理人员添加"))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(BackupList.value, (item, index) => {
                    return (_openBlock(), _createBlock(titleButton, {
                      key: index,
                      name: item.label,
                      sign: item.code,
                      value: item.num,
                      onOnChangeValue: updateRealData,
                      minValue: 0
                    }, null, 8, ["name", "sign", "value"]))
                  }), 128))
                ]))
          ]),
          _: 1
        }, 8, ["show"]))
      : _createCommentVNode("", true)
  ]))
}
}

})